import PropTypes                                  from 'prop-types';
import * as React                                 from 'react';
import { connect }                                from 'react-redux';
import { setForceSecretConnexion }                from '../../dmpconnect/actions';
import { dmpStatuses, userAuthorizationStatuses } from '../../dmpconnect/constants';
import { isPatientMinor }                         from '../../dmpconnect/helpers/directAuthenticationDMPStatus';
import TitleTooltip                               from '../Common/TitleTooltip';
import DmpAuthorization, { displayModes }         from '../DMPAuthorization/DMPAuthorization';

const DmpAccessButton     = ({
  noButton,
  authorization,
  ins, status, accessDMP,
  isTreatingPhysician,
  regulationMode,
  isMinorStrict,
  isMinor,
  dispatch,
}) => {
  const accessButton = (
    <TitleTooltip
      id={`dmp-access-${ins}`}
      text="Accéder au dossier"
    >
      <button
        type="button"
        className="btn btn-sand btn-sm"
        style={{ fontWeight: '500' }}
        onClick={() => accessDMP(ins)}
      >
        {isTreatingPhysician ? (
          <i className="ic-dmp-gp-on"/>
        ) : (
          <i className="ic-dmp-simple-access"/>
        )}
        DMP
      </button>
    </TitleTooltip>
  );
  
  return (
    <>
      {status === dmpStatuses.DMPExist && (
        <>
          {authorization === userAuthorizationStatuses.AuthorizationExist ? (
            <>
              {noButton ? (
                <>
                  {isTreatingPhysician ? (
                    <i className="ic-dmp-gp-on"/>
                  ) : (
                    <i className="ic-dmp-simple-access"/>
                  )}
                </>
              ) : (
                <>
                  {!isMinor && isMinorStrict ? (
                    <>
                      {accessButton}
                      
                      <TitleTooltip
                        id={`dmp-access-secret-${ins}`}
                        text="Accéder au dossier en connexion secrète"
                      >
                        <button
                          type="button"
                          className="btn btn-sand btn-sm"
                          style={{ fontWeight: '500' }}
                          onClick={() => {
                            dispatch(setForceSecretConnexion(ins, true));
                            accessDMP(ins);
                          }}
                        >
                          <i className="las la-user-secret mr-2" style={{ fontSize: '1.5rem' }}/>
                          DMP - Connexion secrète
                        </button>
                      </TitleTooltip>
                    </>
                  ) : (
                    accessButton
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {noButton ? (
                <i className="ic-dmp-no-autorisation"/>
              ) : (
                <>
                  {(
                     authorization === userAuthorizationStatuses.AuthorizationExpired
                     || authorization === userAuthorizationStatuses.NoAuthorization
                   ) && (
                     <DmpAuthorization
                       displayMode={regulationMode ? displayModes.EMERGENCY : displayModes.NORMAL}
                       ins={ins}
                       regulationMode={regulationMode}
                     />
                   )}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};
DmpAccessButton.propTypes = {
  dispatch           : PropTypes.func.isRequired,
  status             : PropTypes.number,
  authorization      : PropTypes.number,
  isTreatingPhysician: PropTypes.bool,
  ins                : PropTypes.string,
  accessDMP          : PropTypes.func,
  noButton           : PropTypes.bool,
  regulationMode     : PropTypes.bool,
  isMinorStrict      : PropTypes.bool,
  isMinor            : PropTypes.bool,
};

DmpAccessButton.defaultProps = {
  status             : null,
  authorization      : null,
  ins                : null,
  accessDMP          : null,
  isTreatingPhysician: false,
  noButton           : false,
  regulationMode     : false,
  isMinorStrict      : false,
  isMinor            : false,
};

function mapStateToProps (state, props) {
  const { ins } = props;
  return {
    isMinorStrict: isPatientMinor(state, ins, true),
    isMinor      : isPatientMinor(state, ins),
  };
}

export default connect(mapStateToProps)(DmpAccessButton);
